import Vue from "vue";
import VueRouter from "vue-router";

//-----------User Management Components--------------------
import Peel_Hunt_Container from "../views/Peel_Hunt_Container.vue";
//--------------Dashboard Components-----------------------

//Stock Screens
import Peel_hunt_screen from "../components/Stock/Peel_Hunt_Screen.vue";

//------------------
import store from "../store";

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isLoggedIn) {
    next();
    return;
  } else {
    if (to.name != "Dashboard") {
      // console.log(to.name)
      next("/dashboard");
    }
  }
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isLoggedIn) {
    next();
    return;
  } else {
    // console.log(to.name)
    if (to.name == "Login" || to.name == "logout") {
      next();
    } else {
      next("/login");
    }
  }
};

const routes = [
  /**
   * User Management
   * */
  // {
  //   path: "/fs/peelHuntContER/",
  //   name: "Peel_Hunt_Container",
  //   component: Peel_Hunt_Container
  // },
  {
    path: "/fs/peelHuntCont",
    name: "Peel_Hunt_Container",
    component: Peel_Hunt_Container
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
